export function createCancellableSignal() {
    const ret = {
        signal: new Promise((_, reject) => {
            ret.cancel = () => {
                reject(new Error("Promise was cancelled"));
            };
        }),
        cancel: () => { },
    };
    return ret;
}
export function wait(milliseconds, result, signal) {
    return new Promise((res, rej) => {
        const timeOut = setTimeout(() => {
            res(result);
        }, milliseconds);
        signal === null || signal === void 0 ? void 0 : signal.catch((err) => {
            rej(err);
            clearTimeout(timeOut);
        });
    });
}
//# sourceMappingURL=utils.js.map